module.exports = __webpack_public_path__ + "img/kleisma1m-m@2.edd9e9cf.webp";